// @ts-check
// Membros da equipe para os seletores de responsável. A lista muda pouco, então fica em memória
// depois da primeira leitura. O servidor já deixa o membro de suporte de fora (contrato 08 de cobrança, seção 7);
// o filtro daqui só garante o mesmo resultado com qualquer servidor.
import { signal } from '@preact/signals';
import { isSupportMember } from '../../../shared/support/support-member.js';
import { api } from './api-client.js';
import { currentWorkspaceMemberState } from './metadata-store.js';

/**
 * @typedef {{ id: string, name: { firstName?: string, lastName?: string }, userEmail?: string, avatarUrl?: string | null, userId?: string | null }} WorkspaceMember
 */

const WORKSPACE_MEMBER_LIMIT = 100;

/** @type {import('@preact/signals').Signal<WorkspaceMember[] | null>} */
export const workspaceMembersState = signal(null);

/** @type {Promise<WorkspaceMember[]> | null} */
let pendingRequest = null;

/**
 * @returns {Promise<WorkspaceMember[]>}
 */
export function loadWorkspaceMembers() {
  if (workspaceMembersState.value) return Promise.resolve(workspaceMembersState.value);
  if (pendingRequest) return pendingRequest;
  pendingRequest = api
    .get('/rest/workspaceMembers', { limit: WORKSPACE_MEMBER_LIMIT })
    .then((body) => {
      const members = body?.data?.workspaceMembers ?? [];
      workspaceMembersState.value = Array.isArray(members) ? members.filter((member) => !isSupportMember(member)) : [];
      return workspaceMembersState.value;
    })
    .catch(() => {
      // Sem a lista os seletores mostram só as opções fixas; a próxima abertura tenta de novo.
      return [];
    })
    .finally(() => {
      pendingRequest = null;
    });
  return pendingRequest;
}

/**
 * Membro atual como responsável padrão (tarefa nova, organizador de evento). Na sessão do suporte não há padrão: o
 * membro de suporte não é da equipe da escola e não receberia os avisos (contrato 08 de cobrança, seção 7.3).
 * @returns {string | null}
 */
export function defaultAssigneeMemberId() {
  const member = currentWorkspaceMemberState.value;
  return member && !isSupportMember(member) ? member.id : null;
}
